module.exports = __webpack_public_path__ + "teqbahn-assets/media/res2.5455f697.png";